import { useLocation } from 'react-router';

/**
 * Returns the `returnPath` that was passed via navigation state, if any.
 *
 * This is a helper so screens can consistently read the
 * return path set by whatever initiated the navigation
 */
const useReturnPath = (): string | undefined => {
  const location = useLocation();
  return (location.state as { returnPath?: string })?.returnPath;
};

export default useReturnPath;
